<template>
	<table class="table" v-if="files.length > 0">
        <thead>
            <th>#</th>
            <th>Imagem</th>
            <th>Nome</th>
            <th>Tamanho</th>
            <th class="right-align">Ações</th>
        </thead>
        <tbody>
            <tr v-for="(file, index) in files">
                <td>{{ index + 1 }}</td>
                <td>
                    <img :src="file.src" width="100" height="100" />
                </td>
                <td>{{ file.nome }}</td>
                <td>{{ file.size }}</td>
                <td class="right-align">
                    <button 
                        class="btn btn-primary"
                        @click="update(file)">
                        <i class="fas fa-eye"></i>
                    </button>
                    <button 
                        class="btn btn-danger"
                        @click="destroy(file)">
                        <i class="fas fa-trash"></i>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
	export default {
		props: ['files'],
		methods: {
			update(file){
				this.$emit('update', file);
			},
            destroy(file){
                this.$emit('destroy', file);
            },
		}
	}
</script>

<style scoped>
    .right-align {
        text-align: right;
    }
</style>